/**
 * @Description 选址-集客点
 */

import { get, post } from '../request';

/**
 * https://yapi.lanhanba.com/project/546/interface/api/80261
 * pc开店区域集客点批量保存
 */
export const batchSave = (params) => {
  return post(`/plan/spot/modelCluster/batchSave`, params);
};
/**
 * https://yapi.lanhanba.com/project/546/interface/api/80268
 * pc录入的集客点开店区域详情
 */
export const getDetail = (params) => {
  return get(`/plan/spot/modelCluster/relation/detail`, params, {
    needCancel: false,
  });
};

/**
 * https://yapi.lanhanba.com/project/546/interface/api/80282
 * pc集客点列表
 */
export const gatherClientList = (params) => {
  return post(`/plan/spot/list`, params);
};

/**
 * https://yapi.lanhanba.com/project/546/interface/api/82662
 * pc集客点详情
 */
export const getPlanSpotById = (params) => {
  return get(`/plan/spot/findById`, params);
};
